module.exports = __webpack_public_path__ + "static/fonts/Inter-Thin.35b7cf4c.ttf";